const tour = {
  actions: {
    startTour: "Start tour",
    takeAgain: "Take again",
  },
  ariaLabel: "Guided tours",
  coachInterfaceIntro: {
    title: "Meet Coach AI",
    description: "A quick introduction to the essentials of Coach AI.",
    smokeDescription:
      "This short animated welcome is ready for the full Coach AI tour.",
    desktop: {
      welcome: {
        title: "Welcome to Coach AI",
        description:
          "Take a quick look around before you start your next safety conversation.",
      },
      scope: {
        title: "Set the scope",
        description:
          "Choose the customer and vehicle group Coach AI should use for your questions. This determines the data available to Coach during the conversation, for example: reports and speeding performance scores.",
      },
      sidebar: {
        title: "Navigate from the rail",
        description:
          "Start a new chat, review History, reuse Saved prompts, browse Coach suggestions, adjust Settings, or return here for tours.",
      },
      history: {
        title: "Return to recent chats",
        description:
          "Review previous Coach AI conversations and export answers.",
      },
      savedPrompts: {
        title: "Reuse helpful questions",
        description:
          "Saved prompts keep your favorite repeatable questions close at hand. Double-click a prompt to send it.",
      },
      coachSuggestions: {
        title: "Use Coach suggestions",
        description:
          "Browse ready-made safety questions from Coach suggestions. Select one to send it to Coach AI.",
      },
      settings: {
        title: "Choose your languages",
        description:
          "Set the app language and the language Coach AI uses for its replies.",
      },
      composer: {
        title: "Start the conversation",
        description:
          "Ask a safety question in your own words or choose a suggested way to begin.",
      },
      closing: {
        title: "You are ready to explore",
        description:
          "Return to Guided tours whenever you want to replay this introduction or discover a new tour.",
      },
    },
    mobile: {
      welcome: {
        title: "Welcome to Coach AI",
        description:
          "Take a quick look around before your next safety conversation.",
      },
      scope: {
        title: "Set the scope",
        description:
          "Choose the customer and vehicle group Coach AI should use for your questions.",
      },
      sidebar: {
        title: "Open the menu",
        description:
          "Use this button to open recent chats, saved prompts, Coach suggestions, settings, and guided tours.",
      },
      history: {
        title: "Return to recent chats",
        description:
          "Review previous Coach AI conversations and export answers.",
      },
      savedPrompts: {
        title: "Reuse helpful questions",
        description:
          "Saved prompts keep your favorite repeatable questions close at hand.",
      },
      coachSuggestions: {
        title: "Use Coach suggestions",
        description:
          "Browse ready-made safety questions from Coach suggestions. Select one to send it to Coach AI.",
      },
      settings: {
        title: "Choose your languages",
        description:
          "Set the app language and the language Coach AI uses for its replies.",
      },
      composer: {
        title: "Start the conversation",
        description:
          "Ask a safety question in your own words or choose a suggested way to begin.",
      },
      closing: {
        title: "You are ready to explore",
        description:
          "Return to Guided tours whenever you want to replay this introduction or discover a new tour.",
      },
    },
  },
  errors: {
    loadFailed: "Unable to load guided tours.",
    completionFailed: "Unable to save tour completion.",
  },
  loading: "Loading guided tours...",
  popover: {
    back: "Back",
    close: "Close tour",
    done: "Done",
    next: "Next",
    progress: "Step {{current}} of {{total}}",
  },
  status: {
    completed: "Completed",
    notStarted: "Not started",
  },
} as const;

export default tour;
